import { Injectable } from "@angular/core";

import { StaticPermissionsEnum } from "../models/permissions-models/permissions.enums";


@Injectable({
  providedIn: 'root'
})
export class AuthPermissionsService {


  private currentUserPermissions: EnumDictionary<StaticPermissionsEnum, boolean>;


  // currentUsersPermissions =
  constructor() {
    this.setCurrentUserPermissions();
  }

  public setCurrentUserPermissions() {
    let dummy: any = {};
    this.currentUserPermissions = Object.assign(dummy, {});
    // this.currentUserPermissions[StaticPermissionsEnum.Add_customer] = true;
    let currentUser: any = JSON.parse(localStorage.getItem("AlghanimCurrentUser"));
    if ((currentUser && currentUser.data && currentUser.data.permissions && currentUser.data.permissions.length > 0)
    ) {
      let permissionsList = currentUser.data.permissions;
      permissionsList.forEach((permissionId: StaticPermissionsEnum) => {
        this.currentUserPermissions[permissionId] = true;
      });
    }
    // if(currentUser && currentUser.data &&currentUser.data.isSuperAdmin){
    //   this.currentUserPermissions = true;
    // }

  }

  public getCurrentUserPermissions(): EnumDictionary<StaticPermissionsEnum, boolean> {
    let temp: EnumDictionary<StaticPermissionsEnum, boolean>;
    let dummy: any = {};
    temp = Object.assign((this.currentUserPermissions || dummy), {});
    return temp;
  }

  public DoesCurrentUserHavePermission(permission: StaticPermissionsEnum): boolean {

    let currentUser: any = JSON.parse(localStorage.getItem("AlghanimCurrentUser"));
    let hasPermission = this.currentUserPermissions[permission];
    if (hasPermission || (currentUser && currentUser.data.isSuperAdmin == true)) {
      return true;
    }

    return false;
  }

  userHasPermissionTo(permission: number | number[], notAdmin: boolean): boolean {
    const user: any = JSON.parse(localStorage.getItem("AlghanimCurrentUser"));
    const permissions: any[] = user?.data?.permissions;

    if (user.data && user.data.isSuperAdmin && (!notAdmin)) {
      
      return true;
      
    }
    if (user && permissions && Array.isArray(permission)) {
      return permission.some(item => permissions.includes(item))
    }
    else if (user && permissions && permissions.includes(permission)) {
      return true;
    }
  }

}

export type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};



